// extracted by mini-css-extract-plugin
module.exports = {"containerMain":"LayoutView_containerMain__1YKZ3","contentWrapper":"LayoutView_contentWrapper__3yMWN","content":"LayoutView_content__1qH86"};